// removed by extract-text-webpack-plugin
module.exports = {"AssetCategoriesBar":"_1k69K07uaqpVYIbiXEcA-m","AssetCategoriesBar--sticky":"_2mOpRJB6eCGLE9Mrwo3Ezi","AssetCategory":"_2PNSpr9SFNgPmmpfPoFqVl","fa":"_2oHJIhjXqNO6eCa6fkTQsd","fa-angle-right":"_1PlU0d_F0QJRb1AxjIRKuv","AssetCategory-wrap":"_1t_EdNmmhyxdjSDRD9sY79","AssetCategory-wrap--active":"qJeO3qEpXb6tEqWZPsQ_I"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AssetCategoriesBar/AssetCategoriesBar.scss
// module id = 2421
// module chunks = 0